

























































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class HdrJiankangshi extends Vue {
  @Prop()
  private message: any;
  private jiwangbingshi: any[] = [
    "高血压病",
    "糖尿病",
    "冠心病",
    "高血脂",
    "慢性支气管炎",
    "肿瘤",
    "易感人群",
    "脑血管病后遗症",
    "脊髓损伤",
    "帕金森病",
    "骨关节病",
    "劲椎病",
    "腰间盘突出",
    "认知障碍",
    "脑性瘫痪",
    "智力低下",
    "脑炎后遗症"
  ];
  private jiazushi: any[] = [
    "肥胖症",
    "支气管哮喘",
    "外伤史",
    "精神疾病",
    "过敏疾病",
    "腿痛病",
    "高血压",
    "高血脂",
    "糖尿病",
    "肝脏病",
    "胃溃疡",
    "癌症",
    "心脏病",
    "骨质疏松"
  ];
  private jinshixiguan: any[] = [
    "常暴饮暴食",
    "常吃宵夜",
    "不吃或少吃早餐",
    "挑食",
    "平素饮食无规律、不定时进餐",
    "饮食正常"
  ];
  private yinshikouwei: any[] = [
    "偏嗜甘甜",
    "偏嗜辛辣",
    "偏嗜酸",
    "偏嗜清淡",
    "偏嗜冷、凉食",
    "偏嗜油腻",
    "偏嗜炙烤",
    "偏嗜冷、凉饮",
    "偏嗜热食",
    "偏嗜咸",
    "喜饮茶",
    "喜饮咖啡",
    "偏嗜滋补",
    "以上都不是，本人无特殊饮食口味"
  ];
  private shenghuo: any[] = [
    "居住地潮湿",
    "少见阳光",
    "周围空气污染",
    "周围噪音多",
    "室内外温差较大",
    "住房紧张",
    "居住条件一般",
    "空气清新、环境好",
    "上下班交通拥挤"
  ];
  private disableChange(val) {
    console.log(val);
  }
}
